import { Component, OnInit } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'bn-transaction-signing-widget-extended',
  templateUrl: './transaction-signing-widget-extended.component.html',
  styles: [],
})
export class TransactionSigningWidgetExtendedComponent implements OnInit {
  modalOptions: NgbModalOptions = {
    keyboard: false,
    backdrop: 'static',
    ariaLabelledBy: 'bb_element_10',
    centered: true,
  };

  constructor() {}

  ngOnInit(): void {}

  validatingData(data: any): string {
    return '';
  }
}
